
import React, { useEffect, useState } from 'react';
import { Document, Page, PDFViewer, View, Font, pdf } from '@react-pdf/renderer';


import { styles, pageStyle } from './examReportCardStyles.js';
import { HeaderLogoSection, HeaderAddressSection, HeaderNameSection } from "./headerSection.js";
import StudentSection from './studentSection.js';
import { ScoreSection } from './scoreSection.js';
import FooterSection from './footerSection.js';
// import LstReportCard from "./lstReportCard.json";

Font.register({
  family: 'Calibri'
  , fonts: [{ src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf" }
    , { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold" }], format: 'truetype'
});




const ExamReportCardPDFAndroid = (props) => {

  const [reportHeader, setReportHeader] = useState(null);
  const [headerName, setHeaderName] = useState('');
  const [lstStudent, setLstStudent] = useState([]);
  const [clsSectionDtls, setClsSectionDtls] = useState(null);
  const [principalSign, setPrincipalSign] = useState('');
  const [teacherSign, setTeacherSign] = useState('');
  const [flgValidated, setFlgValidated] = useState(false);
  const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);

  useEffect(() => {
    props.showLoader();
    setReportHeader(props.reportCard.reportHeader);
    setHeaderName(props.reportCard.headerName);
    setLstStudent(props.reportCard.lstStudent);
    setClsSectionDtls(props.reportCard.clsSectionDtls);
    setPrincipalSign(props.principalSignUrl);
    setTeacherSign(props.teacherSignUrl);
    setFlgValidated(props.flgValidated);
    return () => {
      setTeacherSign("");
    };
    // Uncomment if you want to log the values
    // console.log("ExamReportCardPDFAndroid called", "reportHeader:", JSON.stringify(props.reportCard.reportHeader, null, 2), "headerName:", props.reportCard.headerName, "lstStudent:", JSON.stringify(props.reportCard.lstStudent, null, 2));
  }, [props.reportCard, props.principalSignUrl, props.teacherSignUrl, props.flgValidated]);


  const pages = [];


  const openDocument = async () => {
    // console.log("openDocument called");
    await setDocumentLoadingCalled(true);
    const document = await generateDocument();

    try {
      // Step 1: Generate the PDF Blob
      const blob = await pdf(document).toBlob();

      // Step 2: Check the file size (in bytes)
      const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB

      // Define a threshold for the file size (for example, 10MB)
      const fileSizeThreshold = 10;

      if (fileSizeInMB > fileSizeThreshold) {
        // If file is too large, suggest downloading
        window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

        // Force download if file is too large
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'AnswerSheet.pdf';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        // Step 3: Attempt to open the PDF in a new tab
        const fileURL = URL.createObjectURL(blob);
        const newTab = window.open(fileURL, '_blank');

        // Step 4: Check if the tab was successfully opened
        if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
          window.alert('Popup blocked. Downloading file instead...');
          const downloadLink = document.createElement('a');
          downloadLink.href = fileURL;
          downloadLink.download = 'AnswerSheet.pdf'; // Set default filename
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      }
    } catch (error) {
      console.error('Error opening or downloading PDF:', error);
    }
    finally {
      props.hideLoader();
      props.closePdf();
    }
  };

  const generateDocument = () => new Promise((resolve) => {
    const generatedDocument = (
      <Document>{pages}</Document>
    );
    resolve(generatedDocument);
  });


  for (let i = 0; i < lstStudent.length; i++) {
    pages.push(
      <Page
        key={lstStudent[i].studentHeader.studentId}
        size="A4" style={pageStyle.page}>
        <View style={pageStyle.page_border}>
          <View style={pageStyle.header_section}>
            <View style={pageStyle.header_logo}>
              <HeaderLogoSection
                logoUrl={props.logoUrl}
                reportHeader={reportHeader}
              />
            </View>
            <View style={pageStyle.header_address}>
              <HeaderAddressSection
                reportHeader={reportHeader}
              />
            </View>
            <View style={pageStyle.header_name}>
              <HeaderNameSection
                headerName={headerName}
              />
            </View>
          </View>
          <View style={pageStyle.student_section}>
            <StudentSection
              studentHeader={lstStudent[i].studentHeader}
              clsSectionDtls={clsSectionDtls}
            />
          </View>
          <View style={pageStyle.score_section}>
            <ScoreSection
              studentHeader={lstStudent[i].studentHeader}
              studentSummary={lstStudent[i].studentSummary}
              lstScholastic={lstStudent[i].lstScholastic}
              lstCoscholastic={lstStudent[i].lstCoscholastic}
              exam={props.exam}
            />
          </View>
          <View style={pageStyle.footer_section}>
            <FooterSection
              principalSign={flgValidated ? principalSign : ""}
              teacherSign={flgValidated ? teacherSign : ""}
            />
          </View>
        </View>
      </Page>
    );
    if (i === lstStudent.length - 1 && !documentOpeningCalled) {
      openDocument();
    }
  }


  return (
    <div>
    </div>
  );
}

export default ExamReportCardPDFAndroid;

